import React, { Component } from "react";

import ImageDetails from "./ImageDetails";
import ImageSkeleton from "./ImageSkeleton";

import { ReactComponent as FullScreenIcon } from "../icons/open_in_full.svg";

class Image extends Component {
  state = {
    index: -1,
    open: false,
    mouseover: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.open !== this.state.open && this.state.open) {
      this.setState({ open: false });
    }
  }

  fullSize = (picture, subtitle) => {
    var index = this.props.pictures.indexOf(picture);
    this.setState({
      index,
      subtitle,
      open: true,
    });
  };

  render() {
    const isEdge = window.navigator.userAgent.indexOf("Edge") !== -1;
    const isIE =
      window.navigator.userAgent.indexOf("Trident") !== -1 && !isEdge;
    return (
      <div style={{ position: "relative" }}>
        <ImageSkeleton
          className={"picture-img"}
          src={`${this.props.image}`}
          width={"100%"}
          height={"200px"}
        />
        <div
          onMouseOver={() =>
            !this.state.mouseover ? this.setState({ mouseover: true }) : null
          }
          onMouseOut={() =>
            this.state.mouseover ? this.setState({ mouseover: false }) : null
          }
          style={{
            width: "100%",
            height: "200px",
            position: "absolute",
            top: 0,
            zIndex: 1,
            cursor: "pointer",
          }}
          onClick={() => this.fullSize(this.props.image)}
          onContextMenu={() =>
            navigator.clipboard.writeText(`${this.props.image}`)
          }
        />
        {this.state.mouseover ? (
          <div
            style={{
              width: "100%",
              height: "200px",
              position: "absolute",
              top: 0,
              alignContent: "center",
              textAlign: "center",
              color: "#00568E",
              fontWeight: "600",
              background: "rgba(255,255,255,0.6)",
            }}
            className="grid"
          >
            {isIE ? null : <FullScreenIcon style={{ margin: "auto" }} />}
            Bild vergrößern
          </div>
        ) : null}
        <ImageDetails
          i={this.state.index}
          images={this.props.pictures}
          open={this.state.open}
        />
      </div>
    );
  }
}

export default Image;
